function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from './need-help.scss';
import template from './need-help.html';

export var NeedHelpComponent = {
  template: template,
  styles: styles,
  controller: /*#__PURE__*/function () {
    function NeedHelpComponentController() {
      "ngInject";_classCallCheck(this, NeedHelpComponentController);
      console.log(this);
    }_createClass(NeedHelpComponentController, [{ key: "showIntercome", value: function showIntercome()

      {
        if (window.Intercom) {
          window.Intercom('show');
        }
      } }]);return NeedHelpComponentController;}() };